import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from 'environments/environment';
import { AppModule } from 'app/app.module';
// import { bootstrapApplication } from '@angular/platform-browser';
// import { AppComponent } from './app/app.component';
// import { provideQuillConfig } from 'ngx-quill';
// import { provideHttpClient } from '@angular/common/http';
// import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';
// import { provideTransloco } from '@ngneat/transloco';

// if (environment.production) {
    enableProdMode();
// }
platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));


// bootstrapApplication(AppComponent, {
//     providers: [
//         // ... other providers
//         provideHttpClient(), // Add this line
//         provideTransloco({
//             config: {
//                 availableLangs: [
//                     {
//                         id: 'en',
//                         label: 'English'
//                     },
//                 ],
//                 defaultLang: 'en',
//                 fallbackLang: 'en',
//                 reRenderOnLangChange: true,
//                 prodMode: environment.production
//             },
//             loader: TranslocoHttpLoader
//         }),
//         provideQuillConfig({
//             modules: {
//                 toolbar: [
//                     ['bold', 'italic', 'underline', 'strike'],
//                     ['blockquote', 'code-block'],
//                     [{ 'header': 1 }, { 'header': 2 }],
//                     [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//                     [{ 'script': 'sub' }, { 'script': 'super' }],
//                     [{ 'indent': '-1' }, { 'indent': '+1' }],
//                     [{ 'direction': 'rtl' }],
//                     [{ 'size': ['small', false, 'large', 'huge'] }],
//                     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
//                     [{ 'color': [] }, { 'background': [] }],
//                     [{ 'font': [] }],
//                     [{ 'align': [] }],
//                     ['clean'],
//                     ['link', 'image', 'video']
//                 ]
//             }
//         })
//     ]
// }).catch(err => console.error(err));
